import React, { useEffect, useState, useCallback } from "react";
import Line from "../main/Line";
import BackButton from "../main/BackButton";
import axios from "../../axios-backend";
import Button from "../main/Button";
import { Link, useLocation } from "react-router-dom";
import Columns from "../main/Columns";

const ViewSizeGuides = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const [sizeGuides, setSizeGuides] = useState([]);

  const getData = useCallback(() => {
    if (id !== null) {
      console.log("Fetching size guides for sizeId:", id);
      axios
        .get("/size-guides", {
          params: {
            sizeId: Number(id),
          },
        })
        .then((data) => {
          console.log("Fetched size guides:", data.data.data);
          setSizeGuides(data.data.data);
        });
    } else {
      return;
    }
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const mapAndRenderSizeGuides = () => {
    console.log("Rendering sizeGuides:", sizeGuides);
    return sizeGuides.map((item) => {
      return (
        <Line type="bottom-line" key={item.id}>
          <Columns width="15%">index: {item.index}</Columns>
          <Columns width="20%">{item.name}</Columns>
          <Columns width="20%">{item.gender ? "Men" : "Women"}</Columns>
          <Columns width="45%">
            <Link
              style={{ marginLeft: "2rem" }}
              to={`/edit-size-guide?id=${item.id}&sid=${id}`}
            >
              <Button>Edit</Button>
            </Link>
            <Link
              style={{ marginLeft: "2rem" }}
              to={`/add-size-guide-img?id=${item.id}&type=imageUrl`}
            >
              <Button>Edit small Image</Button>
            </Link>
            <Link
              style={{ marginLeft: "2rem" }}
              to={`/add-size-guide-img?id=${item.id}&type=largeImgUrl`}
            >
              <Button>Edit large Image</Button>
            </Link> </Columns>
        </Line>
      );
    });
  };

  return (
    <>
      <BackButton />
      <Line type="bottom-line" style={{ justifyContent: "space-around" }}>
        <Columns width="15%">Size Guide List</Columns>
        <Columns width="20%">Name</Columns>
        <Columns width="20%">Gender</Columns>
        <Columns
          className="buttonColumn"
          style={{ flex: 1, minWidth: 200, maxWidth: 'none', width: 'auto', whiteSpace: 'normal', overflow: 'visible', textOverflow: 'unset', display: 'block' }}
        >
          <Link to={`/edit-size-guide?sid=${id}`}>
            <Button
              style={{ minWidth: 200, maxWidth: 'none', width: 'auto', whiteSpace: 'normal', overflow: 'visible', textOverflow: 'unset', display: 'inline-block' }}
            >
              Add New Size Guide
            </Button>
          </Link>
        </Columns>

      </Line>
      {mapAndRenderSizeGuides()}
    </>
  );
};

export default ViewSizeGuides;
